import { render, staticRenderFns } from "./MTableBody.vue?vue&type=template&id=1cdee20b"
import script from "./MTableBody.vue?vue&type=script&lang=js"
export * from "./MTableBody.vue?vue&type=script&lang=js"
import style0 from "./MTableBody.vue?vue&type=style&index=0&id=1cdee20b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports